import { ShieldCheck, Fire, Lightning, Drop, Warning, Elevator, Gear, Sun, Tree, Flame } from "@phosphor-icons/react";

export const STATUS = {
  valid: { label: "Valid", cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/30", dot: "bg-emerald-500", hex: "#15803d" },
  expiring: { label: "Expiring", cls: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30", dot: "bg-amber-500", hex: "#b45309" },
  expired: { label: "Expired", cls: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30", dot: "bg-red-500", hex: "#b91c1c" },
  missing: { label: "No certificate", cls: "bg-muted text-muted-foreground border-border", dot: "bg-muted-foreground/60", hex: "#6b7280" },
};

export const CATEGORY_ICON = { Gas: Flame, Electrical: Lightning, Fire: Fire, Water: Drop, Asbestos: Warning, Lifting: Elevator, Plant: Gear, Energy: Sun, Grounds: Tree, Other: ShieldCheck };

export const fmtD = (iso) => (iso ? new Date(iso.length > 10 ? iso : iso + "T00:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export const daysText = (r) => {
  if (r.status === "missing") return "Not yet certified";
  if (r.days_left === null || r.days_left === undefined) return "";
  if (r.days_left < 0) return `${Math.abs(r.days_left)}d overdue`;
  if (r.days_left === 0) return "Expires today";
  return `${r.days_left}d left`;
};

export const scoreTone = (score) => (score === null || score === undefined ? "text-muted-foreground" : score >= 90 ? "text-emerald-600" : score >= 60 ? "text-amber-600" : "text-red-600");

export const intervalText = (m) => (!m ? "—" : m % 12 === 0 ? `${m / 12} yr${m / 12 > 1 ? "s" : ""}` : `${m} mo`);
